module.exports = __webpack_public_path__ + "img/down-banner-top.a7f6b997.png";